export type VerificationErrorSource = 'script' | 'verify' | null

export function applyScriptSetError(message: string | null): {
  message: string | null
  source: VerificationErrorSource
} {
  const text = message == null ? '' : String(message).trim()
  if (!text) return { message: null, source: null }
  return { message: text, source: 'script' }
}

/**
 * Field verify (regexp / format) must not wipe VisualEntity.setError.
 * Blur awaits focusLost, so a button onClick can setError and then lose it
 * when verify() resumes and clears the message first.
 */
export function applyFieldVerifyResult(args: {
  source: VerificationErrorSource
  currentMessage: string | null
  skipped: boolean
  regexpFailed: boolean
  regexpMessage: string | null
  formatFailed: boolean
  formatMessage: string | null
}): { message: string | null; source: VerificationErrorSource; valid: boolean } {
  if (args.skipped) {
    if (args.source === 'script' && args.currentMessage) {
      return { message: args.currentMessage, source: 'script', valid: true }
    }
    return { message: null, source: null, valid: true }
  }
  if (args.regexpFailed) {
    return {
      message: args.regexpMessage || 'Validation failed',
      source: 'verify',
      valid: false,
    }
  }
  if (args.formatFailed) {
    return {
      message: args.formatMessage || 'Validation failed',
      source: 'verify',
      valid: false,
    }
  }
  if (args.source === 'script' && args.currentMessage) {
    return { message: args.currentMessage, source: 'script', valid: true }
  }
  return { message: null, source: null, valid: true }
}
